// État global du système d'optimisation
export const state = {
    initialWidth: window.innerWidth,
    containerWidths: new Map(),
    images: new Map(),
    backgrounds: new Map(),
    formats: null,
    observer: null,
    formatsPromise: null,
    measurementCache: new Map(),
    cacheValidUntil: 0,
    cacheDuration: 100
};

// Cache DOM
export let pictureElements = [];
export let aiImages = [];
export let aiBgElements = [];
